<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
<link href='https://fonts.googleapis.com/css?family=Comfortaa' rel='stylesheet'>


<div shadowdomRoot #shadowdomRoot>
  <router-outlet></router-outlet>
</div>

